export const uses24HourClock = (language: string): boolean => {
  const parts = new Intl.DateTimeFormat(language, { hour: 'numeric' }).formatToParts(new Date(2020, 0, 1, 13, 0, 0));
  return !parts.some(part => part.type === 'dayPeriod');
};
